import { Component, OnInit, QueryList, ViewChildren, inject, input, output } from "@angular/core";
import { IInteraction, GenericErrorHandler } from "../../../../core-ui";
import { InteractionService } from "../../../services";
import { AnalyticsService } from "../../../../core-ui/services/analytics.service";
import { IShareLinkAction } from "../share-link.component";
import {
  IMenuItemContainer,
  MENU_ITEM_CONTAINER_TOKEN,
  MenuItemComponent,
} from "../../../../modules/shared/components";

@Component({
  selector: "app-share-link-widget",
  templateUrl: "./widget.component.html",
  styleUrls: ["./widget.component.scss"],
  providers: [
    {
      provide: MENU_ITEM_CONTAINER_TOKEN,
      useExisting: ShareLinkWidgetComponent,
    },
  ],
  standalone: false,
})
export class ShareLinkWidgetComponent
  implements OnInit, IShareLinkAction, IMenuItemContainer
{
  private interactionService = inject(InteractionService);
  private errorHandler = inject(GenericErrorHandler);

  readonly interaction = input<IInteraction>(undefined);
  readonly ticket = input<string>(undefined);

  readonly completed = output<void>();
  readonly openChange = output<boolean>();

  @ViewChildren(MenuItemComponent) menuItems: QueryList<MenuItemComponent>;

  ngOnInit(): void {}

  getMenuItems(): MenuItemComponent[] {
    return this.menuItems.toArray();
  }

  shareLink() {
    try {
      this.interactionService.invite(
        this.interaction().getType(),
        this.interaction(),
        this.ticket()
      );
      // this.analyticsService.trackInvitationSent(this.interaction);
      // this.renewCustomerLink();
      this.completed.emit();
    } catch (ex) {
      this.errorHandler.handleError(ex);
    }
  }
}
